
import { Vue, Component } from 'vue-property-decorator'
import { ClueService } from '@/services'

@Component({
    components: {
    }
})
export default class LevySetting extends Vue {
    private levyId = 0
    private levy: any = {}
    private isLoading = false

    private mounted() {
        this.levyId = +this.$route.params.id
        this.getLevyDetail()
    }

    private async getLevyDetail() {
        const params = { id: this.levyId }
        this.isLoading = true
        const result = await ClueService.getLevyDetail(params)
        this.isLoading = false
        if (result.status === 200) {
            this.levy = result.data
        }
    }
}
